import { TextField, useFormField } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import { BodyText, LabelText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { useRef, forwardRef } from 'react';
import { LocationIcon } from 'components/core/location_icon';
import { useAdvancedSortable, VerticalSortableContext } from 'components/core/sortable';
import { useEventType } from 'features/event_type_provider';
import { InputContainer, PanelContentContainer, PanelContentHeader, PanelContentSubtitle, PanelContentTitle, StyledDragIcon } from '../styles';
import { showLocationQuestion } from './helpers';
const containerIsDraggingCss = "c1x6kcm";
const containerCss = "crl8g4t";
const Container = forwardRef((props, ref) => {
  const {
    isDragging,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, {
    [containerIsDraggingCss]: isDragging
  }, props.className)} />;
});
const contentCss = "cbtmwe0";
const Content = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(contentCss, props.className)} />;
});
const innerContentCss = "ic827l";
const InnerContent = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(innerContentCss, props.className)} />;
});
const locationIconContainerCss = "lykxj7q";
const LocationIconContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(locationIconContainerCss, props.className)} />;
});
const INFO_ATTRIBUTE_FOR_KIND = {
  custom: 'location',
  physical: 'location'
};
const getPhoneNumberInfo = location => location.phoneNumber || location.phone_number;
const infoForLocation = location => {
  const defaultInfo = I18n.t(`publisher.event_types.location.${location.kind}.label`);
  const rawInfo = location.kind === 'inbound_call' ? getPhoneNumberInfo(location) : location[INFO_ATTRIBUTE_FOR_KIND[location.kind]];
  return rawInfo || defaultInfo;
};
const CardContent = ({
  title,
  kind,
  dndProps = {}
}) => <InnerContent>
    <StyledDragIcon {...dndProps} />
    <Content draggable>
      <LocationIconContainer>
        <LocationIcon kind={kind} size="large" />
      </LocationIconContainer>
      <BodyText>
        {title}
      </BodyText>
    </Content>
  </InnerContent>;
const DraggableCard = ({
  card,
  boundingRef
}) => {
  const {
    sortable: {
      isDragging,
      attributes,
      listeners,
      setNodeRef
    },
    itemStyle
  } = useAdvancedSortable({
    id: card.id
  });
  return <Container id={card.htmlId} ref={setNodeRef} isDragging={isDragging} {...itemStyle}>
      <CardContent dndProps={{
      className: 'drag-handler',
      ...attributes,
      ...listeners
    }} boundingRef={boundingRef} {...card} />
    </Container>;
};
export const LocationQuestionSection = () => {
  const eventType = useEventType();
  const boundingRef = useRef(null);
  const [{
    value: locationConfigurations
  }, _, {
    setValue,
    setTouched
  }] = useFormField({
    name: 'locationConfigurations'
  });
  const hasLocationQuestion = showLocationQuestion(eventType);
  if (!hasLocationQuestion) return null;
  const formattedLocations = locationConfigurations.map((choice, index) => ({
    ...choice,
    title: infoForLocation(choice),
    htmlId: `location-${index}`
  }));
  const setItems = items => {
    setValue(items);
    setTouched(true);
  };
  return <PanelContentContainer section>
      <PanelContentHeader>
        <PanelContentTitle>
          {I18n.t('publisher.event_types.invitee_questions.edit_location_question_label')}
        </PanelContentTitle>
        <PanelContentSubtitle>
          {I18n.t('publisher.event_types.invitee_questions.location_customize')}
        </PanelContentSubtitle>
      </PanelContentHeader>
      <PanelContentContainer subsection>
        <InputContainer>
          <LabelText size="medium">
            {I18n.t('publisher.event_types.invitee_questions.location_input_label')}
          </LabelText>
          <TextField name="locationLabel" id="location_label_input" placeholder={I18n.t('publisher.event_types.invitee_questions.location_input_placeholder')} />
        </InputContainer>
        <InputContainer>
          <LabelText size="medium">
            {I18n.t('publisher.event_types.invitee_questions.location_options')}
          </LabelText>
          <VerticalSortableContext items={formattedLocations} setItems={setItems}>
            {formattedLocations.map(location => <DraggableCard key={location.id} card={location} boundingRef={boundingRef} />)}
          </VerticalSortableContext>
        </InputContainer>
      </PanelContentContainer>
    </PanelContentContainer>;
};

require("./location_question_section.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./location_question_section.js");